// Action Types
export const FETCH_COMP_FIN_REQUEST =
  "FETCH_COMP_FIN_REQUEST";
export const FETCH_COMP_FIN_SUCCESS =
  "FETCH_COMP_FIN_SUCCESS";
export const FETCH_COMP_FIN_FAILURE =
  "FETCH_COMP_FIN_FAILURE";

// Action Creators
export const fetchCompFinancialRequest = (payload) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_COMP_FIN_REQUEST,
      payload,
    });
  };
};
export const fetchCompFinancialSuccess = (data) => ({
  type: FETCH_COMP_FIN_SUCCESS,
  payload: data,
});


export const fetchCompFinancialFailure = (error) => ({
  type: FETCH_COMP_FIN_FAILURE,
  payload: error,
});


